import { auth,db } from "./index";

export const signIn = async ({ email, password }) => {
  return await auth.signInWithEmailAndPassword(email, password);
};

export const getIdToken = async (user) => {
  return await user.getIdToken();
};

export const getCurrentUserToken = async() => {
  let idToken = await auth.currentUser.getIdToken(true);
  return idToken
}

export const createUserProfileDocument = async (userAuth, additionalData) => {
  
  if (!userAuth) return;
  const userRef = db.doc(`users/${userAuth.uid}`);
  const snapShot = await userRef.get();

  if (!snapShot.exists) {
    const { email } = userAuth;
    try {
      await userRef.set({
        email,
        role: "user",
        createdAt: Date.now(),
        ...additionalData,
      });
    } catch (error) {
      console.log("error creating user", error.message);
    }
  }

  return userRef;
}; 

export const sendVerificationEmail = async (currentUser) => {
  return await auth.currentUser.sendEmailVerification()
    .then(() => {
      console.log("Verification email has been sent");
    });
}; 

export const sendResetPasswordEmail = async(email) => {
    return await auth.sendPasswordResetEmail(email).then(() => {
      console.log("Password reset email has been sent");
    });
}

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      unsubscribe();
      resolve(userAuth);
    }, reject);
  });
};

export const getUserInformation =async(user)=>{
  return await db.collection("users").where("email", "==", user.email).get();
  }


